export default __webpack_public_path__ + "static/media/timer.3cf09f5e.svg";